
if (!customElements.get('modal-dialog')) {
  class ModalDialog extends HTMLElement {
    constructor() {
      super();
      this.modal = this.querySelector('.modal');
      this.modalContent = this.querySelector('.modal-content');
      this.closeButton = this.querySelector('.modal-close');
    }

    connectedCallback() {
      this.init();
    }

    init() {
      this.modalTriggers = document.querySelectorAll(`[data-modal-trigger="${this.id}"], a[href*="#${this.id}"]`);
      this.bindEvents();
    }

    bindEvents() {
      this.modalTriggers?.forEach(trigger => {
        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          if (e.target.nodeName === 'A') {
            e.stopPropagation();
          }
          this.open();
        })
      })

      if (this.closeButton) {
        this.closeButton.addEventListener('click', () => this.close());
      }

      if (this.modal) {
        this.modal.addEventListener('click', (e) => {
          if (e.target === this.modal) {
            this.close();
          }
        });
      }

      // clicks inside shouldnt close it
      if (this.modalContent) {
        this.modalContent.addEventListener('click', (e) => {
          e.stopPropagation();
        });
      }

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen()) {
          this.close();
        }
      });

      if (this.form) {
        this.form.addEventListener('submit', (e) => this.handleFormSubmit(e));
      }
    }

    open() {
      this.modal.classList.add('open');
      
      // only build the share url if the field is there
      const cartLinkField = this.querySelector('#sharecartCartLink');
      if (cartLinkField) {
        this.generateSharedCartUrl().then(url => {
          cartLinkField.value = url;
        });
      }

      this.dispatchEvent(new CustomEvent('modal:opened', { bubbles: true }));
    }

    close() {
      this.modal.classList.remove('open');
      
      this.dispatchEvent(new CustomEvent('modal:closed', { bubbles: true }));
    }

    isOpen() {
      return this.style.display === 'block';
    }

    handleFormSubmit(e) {
      
      this.dispatchEvent(new CustomEvent('modal:formSubmit', { 
        bubbles: true, 
        detail: { form: this.form } 
      }));
    }

    setFormData(data) {
      Object.keys(data).forEach(key => {
        const input = this.querySelector(`[name="${key}"]`);
        if (input) {
          input.value = data[key];
        }
      });
    }

    resetForm() {
      if (this.form) {
        this.form.reset();
      }
    }

    async generateSharedCartUrl() {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        
        if (!cart.items || cart.items.length === 0) {
          return window.location.origin + '/?shared-cart=true&items=';
        }
        
        const itemsParam = cart.items.map(item => `${item.variant_id}:${item.quantity}`).join(',');
        const baseUrl = window.location.origin;
        
        return `${baseUrl}/cart/?shared-cart=true&items=${itemsParam}`;
      } catch (error) {
        console.error('Error generating shared cart URL:', error);
        return window.location.origin + '/cart/?shared-cart=true&items=';
      }
    }
  }

  customElements.define('modal-dialog', ModalDialog);
}